import React, { useCallback } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Navigation, Virtual } from "swiper/modules";
import classNames from "classnames";
import LsLoading from "Components/LsLoading";
import classes from "./styles.module.scss";

// const classes:any = {};

//should be unique
const lazyPreloaderClass = "imageSwiperLazyPreloaderClass";

export interface ImageSwiperProps {
   imageUrls: string[],
   className?: string,
   inCard?: boolean;
}

export const ImageSwiper: React.FC<ImageSwiperProps> = ({ imageUrls, className, inCard }) => {
   return <Swiper
      modules={[Navigation, Virtual]}
      className={classNames(classes.imageSwiper, className, { [classes.cardImageSwiper]: inCard })}
      loop={imageUrls.length > 1}
      slidesPerView={1}
      simulateTouch
      lazyPreloadPrevNext={1}
      virtual
      lazyPreloaderClass={lazyPreloaderClass}
   >
      {
         imageUrls
            .map((imageUrl, index) => <SwiperSlide key={imageUrl} virtualIndex={index}>
               <img className={classNames(classes.image, "image-swiper")} src={imageUrl} loading="lazy" />
               <LsLoading className={lazyPreloaderClass} isLoading={true} />
            </SwiperSlide>)
      }

      {
         imageUrls.length > 1
            ? <>
               <ButtonPrev />
               <ButtonNext />
            </>
            : null
      }
   </Swiper>
}

const ButtonPrev: React.FC = () => {
   const swiper = useSwiper();
   const clickHandler = useCallback<React.MouseEventHandler<HTMLElement>>(e => {
      swiper.slidePrev();
      e.stopPropagation();
      e.preventDefault();
   }, []);
   return <div slot="container-end" className="swiper-button swiper-button-prev" onClick={clickHandler}></div>
}

const ButtonNext: React.FC = () => {
   const swiper = useSwiper();
   const clickHandler = useCallback<React.MouseEventHandler<HTMLElement>>(e => {
      swiper.slideNext();
      e.stopPropagation();
      e.preventDefault();
   }, []);
   return <div slot="container-end" className="swiper-button swiper-button-next" onClick={clickHandler}></div>
}
